import React from 'react';
import HighlightFeature, {
  ACTION_RESULTS_TABLE,
  BOTTOM,
} from '@/components/HighlightFeature';

export const ResultsOnboarding = () => (
  <HighlightFeature
    position={BOTTOM}
    text={
      <span>
        You can see a <b>preview</b> of your <b>results</b> here on the right.
      </span>
    }
    targetAction={ACTION_RESULTS_TABLE}
    style={{ minWidth: '250px' }}
    delay={1000}
  />
);
